import { useState, useEffect, useCallback } from 'react';
import useDebounce from 'utils/hooks/useDebounce';
import { ArticleWithLink } from '../blogTypes';
import { addLinksToArticle } from '../blogUtils';
import blogApi from '../blogApi';

const useSearchArticles = (term: string) => {
  const debounceSearch: string = useDebounce(term, 500);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState({
    total: 0,
    totalPages: 0,
    page: 0,
  });
  const [result, setResult] = useState<ArticleWithLink[]>([]);

  useEffect(() => {
    setIsLoading(true);
    const searchArticles = async () => {
      const searchResponse = await blogApi.searchArticles({
        searchTerm: debounceSearch,
        page: 1,
        perPage: 10,
      });
      if (searchResponse.ok) {
        setResult(searchResponse.data.posts.map(addLinksToArticle));
        setPagination({
          total: searchResponse.data.total,
          totalPages: searchResponse.data.totalPages,
          page: searchResponse.data.page,
        });
      }
      setIsLoading(false);
    };
    searchArticles();
  }, [debounceSearch]);

  const getSearchArticleByPage = useCallback(
    async (page: number) => {
      const searchResponse = await blogApi.searchArticles({
        searchTerm: debounceSearch,
        page,
        perPage: 10,
      });
      if (searchResponse.ok) {
        setResult(searchResponse.data.posts.map(addLinksToArticle));
        setPagination({
          total: searchResponse.data.total,
          totalPages: searchResponse.data.totalPages,
          page: searchResponse.data.page,
        });
      }
      setIsLoading(false);
    },
    [debounceSearch],
  );

  return {
    debounceSearch,
    result,
    isLoading,
    pagination,
    getSearchArticleByPage,
  };
};

export default useSearchArticles;
